import { Alert, AlertTitle, PageLayout, Stack } from '@cmg/design-system';
import React, { useCallback, useEffect } from 'react';

import { CalendarHeader } from './components/calendar-header/CalendarHeader';
import { CalendarTabPanel } from './components/calendar-tabs/CalendarTabPanel';
import { CALENDAR_TABS } from './components/calendar-tabs/CalendarTabs.model';
import { useCalendarTabs } from './hooks/useCalendarTabs';
import { useGetCalendarGridProps } from './hooks/useGetCalendarGridProps';
import { useResetCalendarToDefault } from './hooks/useResetCalendarToDefault';

const CalendarRoute: React.FC = () => {
  const [activeTab, setActiveTab] = useCalendarTabs();
  const { fetchGridRowData, activeFilterCount, totalRowCount, error, ...gridProps } =
    useGetCalendarGridProps({ tab: activeTab });

  const handleResetFilters = useCallback(() => {
    gridProps.dataGridContextRef.current?.setFilters(null);
  }, [gridProps.dataGridContextRef]);

  const handleResetGridToDefault = useResetCalendarToDefault({
    initialGridState: gridProps.initialState,
    dataGridContext: gridProps.dataGridContextRef.current,
  });

  useEffect(() => {
    void fetchGridRowData();
  }, [fetchGridRowData]);

  return (
    <Stack height="100%">
      <PageLayout
        flex={1}
        header={
          <CalendarHeader
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            onResetFilters={handleResetFilters}
            activeFilterCount={activeFilterCount}
            onResetGridToDefault={handleResetGridToDefault}
            alert={
              error && (
                <Alert severity="error" aria-label="Failed to load offerings">
                  <AlertTitle>Failed to load Offerings</AlertTitle>
                  {error.message}
                </Alert>
              )
            }
          />
        }
      >
        {CALENDAR_TABS.map(tab => (
          <CalendarTabPanel
            key={tab}
            tab={tab}
            isActive={activeTab === tab}
            gridProps={gridProps}
          />
        ))}
      </PageLayout>
    </Stack>
  );
};

export default CalendarRoute;
